var _path, _path2, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3763 21.4061C11.7248 20.7546 11.7248 19.6983 12.3763 19.0468L19.0494 12.3737C19.7009 11.7222 20.7572 11.7222 21.4087 12.3737L43.0963 34.0612C43.4092 34.3741 43.5849 34.7984 43.5849 35.2409V41.914C43.5849 42.8354 42.838 43.5823 41.9167 43.5823H35.2436C34.8011 43.5823 34.3768 43.4065 34.0639 43.0936L17.3815 26.4112L12.3763 21.4061Z",
    fill: "#F46940"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_610_18265",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 33,
    height: 33
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3763 21.4061C11.7248 20.7546 11.7248 19.6983 12.3763 19.0468L19.0494 12.3737C19.7009 11.7222 20.7572 11.7222 21.4087 12.3737L43.0963 34.0612C43.4092 34.3741 43.5849 34.7984 43.5849 35.2409V41.914C43.5849 42.8354 42.838 43.5823 41.9167 43.5823H35.2436C34.8011 43.5823 34.3768 43.4065 34.0639 43.0936L17.3815 26.4112L12.3763 21.4061Z",
    fill: "#F46940"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_610_18265)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.9014,
    y: 26.5974,
    width: 4.28588,
    height: 25.8155,
    transform: "rotate(-45 16.9014 26.5974)",
    fill: "#FF7C56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.6943,
    y: 19.804,
    width: 4.28588,
    height: 25.8155,
    transform: "rotate(-45 23.6943 19.804)",
    fill: "#FF7C56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.9795,
    y: 45.4856,
    width: 17.8672,
    height: 11.1792,
    transform: "rotate(-45 32.9795 45.4856)",
    fill: "#FFEAE3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7803,
    y: 43.8853,
    width: 5.98565,
    height: 3.82315,
    transform: "rotate(-45 39.7803 43.8853)",
    fill: "#3B090A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.60645,
    y: 23.7261,
    width: 23.5128,
    height: 6.66828,
    transform: "rotate(-45 7.60645 23.7261)",
    fill: "#FEA509"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.9111,
    y: 28.4087,
    width: 23.5128,
    height: 4.49552,
    transform: "rotate(-45 11.9111 28.4087)",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_610_18265)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.3184,
    y: 24.4521,
    width: 1.44716,
    height: 6.01448,
    transform: "rotate(-45 16.3184 24.4521)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.7529,
    y: 22.0171,
    width: 1.44716,
    height: 6.01448,
    transform: "rotate(-45 18.7529 22.0171)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.1885,
    y: 19.5823,
    width: 1.44716,
    height: 6.01448,
    transform: "rotate(-45 21.1885 19.5823)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.623,
    y: 17.1472,
    width: 1.44716,
    height: 6.01448,
    transform: "rotate(-45 23.623 17.1472)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_610_18265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.7148,
    height: 3.08284,
    fill: "white",
    transform: "translate(16.5811 24.7371) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencilIcon.ddeedb2c44bb4aed6007474065e67954.svg";
export { ForwardRef as ReactComponent };